<template>
    <div class="autocomplete">
        <input
            v-bind="$attrs"
            :value="searchTerm"
            @keydown.down="onArrowDown"
            @keydown.up="onArrowUp"
            @keydown.enter="onEnter"
            v-on="listeners"
            :placeholder="placeholder"
            type="text"
            class="search__input"
            :maxlength="maxCharacters"
        />
        <i class="icon--md icon-search search__input--icon"></i>
        <ul
            v-show="isLoading"
            class="autocomplete-results"
        >
            <li
                class="autocomplete-result"
            >
                {{ $t('loading') | capitalize }}
            </li>
        </ul>
        <ul
            v-show="isOpen"
            class="search-results"
        >
            <li
                v-for="(result, i) in results"
                :key="result"
                @click="setResult(result)"
                class="search-results__item"
                :title="result"
                :class="{ 'is-active': i === arrowCounter }"
            >
                {{ result }}
            </li>
        </ul>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { omit as _omit } from '@lodash';

    export default Vue.component('AutoCompleteInput', {
        props: {
            value: {
                type: String,
                required: true,
            },
            placeholder: {
                type: String,
                required: false,
                default: '',
            },
            minCharacters: {
                type: Number,
                default: 0,
            },
            maxCharacters: {
                type: Number,
                default: 32,
            },
            results: {
                type: Array,
                default: () => [],
            },
            isAsync: {
                type: Boolean,
                default: false,
            },
            areSuggestionsShown: {
                type: Boolean,
                default: false,
            }
        },
        data() {
            return {
                arrowCounter: -1,
                isLoading: false,
            };
        },
        computed: {
            searchTerm: {
                get() {
                    return this.value;
                },
                set(newValue) {
                    this.$emit('input', newValue);
                },
            },
            isOpen: {
                get() {
                    return this.areSuggestionsShown;
                },
                set(value) {
                    this.$emit('suggestionsStateChange', value);
                }
            },
            listeners() {
                const l = _omit(this.$listeners, ['input']);
                l.input = (event) => {
                    // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                    this.searchTerm = event.target.value.slice(0, this.maxCharacters);
                    // workaround for https://github.com/vuejs/vue/issues/7042
                    this.onChange();
                };
                return l;
            }
        },
        methods: {
            closeSuggestions() {
                this.isOpen = false;
                this.arrowCounter = -1;
            },
            setResult(result) {
                this.searchTerm = result;
                this.isOpen = false;
                this.$emit('itemClick');
            },
            onChange() {
                if (this.value.trim().length >= this.minCharacters) {
                    if (this.isAsync) {
                        this.isLoading = true;
                    } else {
                        this.isOpen = true;
                    }
                }
            },
            onArrowDown() {
                if (this.arrowCounter < this.results.length - 1) {
                    this.arrowCounter = (this.arrowCounter + 1);
                }
            },
            onArrowUp() {
                if (this.arrowCounter > 0) {
                    this.arrowCounter = this.arrowCounter - 1;
                }
            },
            onEnter(event) {
                if (this.arrowCounter !== -1) {
                    this.setResult(this.results[this.arrowCounter]);
                    event.preventDefault();
                } else {
                    // will submit because of default behaviour
                }
            },
            handleClickOutside(event) {
                if (!this.$el.contains(event.target)) {
                    this.closeSuggestions();
                }
            }
        },
        mounted() {
            document.addEventListener('click', this.handleClickOutside);
        },
        destroyed() {
            document.removeEventListener('click', this.handleClickOutside);
        },
        watch: {
            results() {
                if (this.isAsync) {
                    this.isOpen = true;
                    this.isLoading = false;
                }
            },
        },
    });
</script>


// WEBPACK FOOTER //
// src/app/modules/shared/components/AutoCompleteInput.vue